import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'whatwg-fetch';
import vueCustomElement from 'vue-custom-element'
import VueAnnouncer from '@vue-a11y/announcer'

Vue.config.productionTip = false;


Vue.use(vueCustomElement);
Vue.use(VueAnnouncer);


App.store = store
App.router = router
Vue.customElement('first-steps', App)